/** M1911, as a thing you can carry. The gun itself is `sim/weapons/guns/m1911.ts`. */

import { NO_ARMOR } from '@/sim/combat/armorMitigation';
import type { WeaponItem } from '@/sim/items/itemContract';

export const M1911_ITEM = {
  id: 'm1911',
  kind: 'weapon',
  label: 'M1911',
  description:
    'A century of service and seven rounds of .45. Slow, heavy, and never once apologetic.',
  rarity: 'common',
  weightKg: 1.1,
  stackLimit: 1,
  equip: {
    slots: ['sidearm', 'primaryWeapon'],
    statDeltas: {},
    armor: NO_ARMOR,
    damageModifiers: [],
  },
  weaponId: 'm1911',
} as const satisfies WeaponItem;
